import React from "react";

const TablaListaDeSeleccionPacientesXNombreN = ({ item,passBuscarDataUser }) => {
    const body={
        nombreUser:item.MPNOMC,
        numeroUser:item.MPCedu,
        tipoDocumentoUser:item.MPTDoc,
        sexoUser:item.MPSexo
    }
    const handleOnclickUser=()=>{
        passBuscarDataUser(body)
    }
  return (
    <tr className="border-b">
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        <button
            onClick={handleOnclickUser}
          type="button"
          className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Seleccionar
        </button>
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
        {item.MPNOMC}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
        {item.MPSexo}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
        {item.MPCedu}
      </td>
      <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
        {item.MPTDoc}
      </td>
    </tr>
  );
};

export default TablaListaDeSeleccionPacientesXNombreN;
